import { inject, injectable } from 'inversify';
import DeliveryScheduleService from 'src/features/checkout/data/service/DeliveryScheduleService';
import {
  DeliveryScheduleRepositoryInterface,
  GetDeliveryScheduleParams,
} from 'src/features/checkout/domain/repositories/DeliveryScheduleRepository.interface';

@injectable()
class DeliveryScheduleRepository
  implements DeliveryScheduleRepositoryInterface
{
  @inject(DeliveryScheduleService)
  private deliveryScheduleService!: DeliveryScheduleService;

  async getDeliverySchedule(params: GetDeliveryScheduleParams) {
    return await this.deliveryScheduleService.getDeliverySchedule(params);
  }
}

export default DeliveryScheduleRepository;
